import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import GenericButton from './GenericButton';

const AcceptTermsModal = props => {
  const { isOpen, acceptedOnClick } = props;

  return (
    <Dialog open={isOpen} scroll="paper" fullWidth maxWidth="md">
      <DialogTitle style={{ display: 'flex', justifyContent: 'center' }}>
        Permissible Use Reminder
      </DialogTitle>
      <DialogContent
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          padding: '1.5rem',
        }}
        dividers
      >
        <div>
          As a valued subscriber, you are welcome to quote data from our
          products in presentations, pitch decks, media plans, ad creative, and
          promotional materials. However, please note that MRI-Simmons data
          cannot be shared with clients or other parts of your company unless
          they have their own subscription to MRI-Simmons.
        </div>
        <div>
          To protect our intellectual property and the confidentiality of our
          data, please refrain from entering our data into any public AI or
          machine learning tools, such as OpenAI, ChatGPT, etc. For further
          information, please contact your Account Team.
        </div>
      </DialogContent>
      <DialogActions
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '1.5rem',
        }}
      >
        <GenericButton
          name="Click To Continue"
          btnStyle="small button margin-0"
          btnDisabled={false}
          onBtnClick={acceptedOnClick}
        />
      </DialogActions>
    </Dialog>
  );
};

AcceptTermsModal.propTypes = {
  isOpen: PropTypes.bool,
  acceptedOnClick: PropTypes.func,
};

export default AcceptTermsModal;
